const checkIsWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) && !window.MSStream;
  };

  export default checkIsWebView;